import styled, { keyframes } from 'styled-components'
import { NavLink } from 'react-router-dom'
import { colors } from '../assets/colors'

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

export const LittleSpan = styled.span`
  box-sizing: border-box;
  color: gray;
  font-family: -apple-system, 'system-ui', 'Segoe UI', Roboto, 'Helvetica Neue',
    Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji',
    'Segoe UI Symbol', 'Noto Color Emoji';
  font-size: 18px;
  text-align: left;
`

//Try
export const TrySpan = styled.span`
  box-sizing: border-box;
  color: 'blue';
  font-family: -apple-system, 'system-ui', 'Segoe UI', Roboto, 'Helvetica Neue',
    Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji',
    'Segoe UI Symbol', 'Noto Color Emoji';
  font-size: 18px;
  foint-weight: 500;
  text-align: left;
`
export const FileInput = styled.input`
  box-sizing: border-box;
  color: #194dbd;
  cursor: default;
  display: none;
  font-family: -apple-system, 'system-ui', 'Segoe UI', Roboto, 'Helvetica Neue',
    Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji',
    'Segoe UI Symbol', 'Noto Color Emoji';
  font-size: 10px;
  line-height: 24px;
  margin: 0;
  overflow: visible;
  white-space: pre;
  width: 100%;
`

export const StyledA = styled(NavLink)`
  font-size: 18px;
  pointer-events: 'none';
  padding-left: 10px;
`

export const StyledMapContainer = styled.div`
  height: 100%;

  margin: 10px;
  background: transparent;
  color: #171212;
  max-width: 1090px;
  min-height: 330px;
  display: flex;
`

export const SpeedHighchartsContainer = styled.div`
  height: 230px;
  width: 80%;
  padding: 0px;
  margin: 10px;
  background: transparent;
`

export const ButtonsGroupContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-evenly;
`
export const SlidersAndButtonsContainer = styled.div`
  padding: 0;
  margin: 0;
  display: flex;
  width: ${(props) =>
    props.chart.current
      ? Math.round(
          props.chart.current.chart.series[0].data[
            props.chart.current.chart.series[0].data.length - 1
          ].plotX - props.chart.current.chart.series[0].data[0].plotX
        ) +
        200 +
        'px'
      : '0px'};
  position: relative;
  left: ${(props) =>
    props.chart.current
      ? props.chart.current.chart.plotLeft +
        props.chart.current.chart.series[0].data[0].plotX +
        5 +
        'px'
      : '0px'};
`

export const SlidersContainer = styled.div`
  width: ${(props) =>
    props.chart.current
      ? Math.round(
          props.chart.current.chart.series[0].data[
            props.chart.current.chart.series[0].data.length - 1
          ].plotX - props.chart.current.chart.series[0].data[0].plotX
        ) +
        200 +
        'px'
      : '1000px'};
`

export const SelectSliderContainer = styled.div`
  width: ${(props) =>
    props.chart.current
      ? Math.round(
          props.chart.current.chart.series[0].data[
            props.chart.current.chart.series[0].data.length - 1
          ].plotX - props.chart.current.chart.series[0].data[0].plotX
        ) +
        66 +
        'px'
      : '1000px'};
  display: flex;
  justify-content: space-between;
  height: 30px;
  padding-top: 5px;
  margin-bottom: 2px;
`

//doit avoir la même largeur que XSliderContainer
export const SelectSliderStyle = styled.div`
  position: relative;
  width: ${(props) => props.position.width + 'px'};
  margin-left: 0px;
  height: 20px;
  display: flex;
`

//doit avoir la même largeur que xRailStyle
export const SelectRailStyle = {
  position: 'absolute',
  width: '100%',
  height: 2,
  marginTop: 15,
  borderRadius: 5,
  backgroundColor: 'transparent',
}

export const XSliderContainer = styled.div`
  width: ${(props) =>
    props.chart.current
      ? props.chart.current.chart.plotWidth + 50 + 'px'
      : '1000px'};
  display: flex;
  justify-content: space-between;
`

//xSliderStyle et xRailStyle doivent avoir la même largeur, donc en % xRailStyle est à 100
export const xSliderStyle = {
  // Give the slider some width
  width: '100%',
  marginLeft: 0,
  position: 'relative',
  left: 0,
  height: 25,
  display: 'flex',
}

export const xRailStyle = {
  position: 'absolute',
  width: '100%',
  left: -1,
  height: 20,
  marginTop: 5,
  borderRadius: 0,
  backgroundColor: 'lightgrey',
}

export const ApplyContainer = styled.div``

export const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
`

export const Loader = styled.div`
  padding: 10px;
  border: 6px solid ${colors.primary};
  border-bottom-color: transparent;
  border-radius: 22px;
  animation: ${rotate} 1s infinite linear;
  height: 0;
  width: 0;
`

//PageSelect
export const PageSelectUl = styled.ul`
  border-radius: 0.25rem;
  box-sizing: border-box;
  color: #212529;
  display: flex;
  font-family: -apple-system, system-ui, 'Segoe UI', Roboto, 'Helvetica Neue',
    Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji',
    'Segoe UI Symbol', 'Noto Color Emoji';
  font-size: 0.75rem;
  justify-content: ${(props) => (props.mobile ? 'end' : 'space-between')};
  line-height: 15px;
  list-style: none;
  margin: 2px 0;
  padding-left: 0;
  text-align: right;
  white-space: nowrap;
`

//SessionItem
export const SeItem = styled.div`
  display: flex;
  align-items: center;
  padding-top: 5px;
  padding-bottom: 5px;
  background-color: ${(props) => props.bg};
  width: 100%;
  color: ${(props) => props.cl};
`

export const SeColumn = styled.span`
  padding: 0 5px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 2;
  width: ${(props) => props.w}%;
  max-width: ${(props) => props.w}%;
  min-width: ${(props) => props.w}%;
  text-align: ${(props) => props.align};
`

export const SpItem = styled.div`
  display: flex;
  align-items: center;
  padding-top: 5px;
  padding-bottom: 5px;
  background-color: ${(props) => props.bg};

  color: ${(props) => props.cl};
`

export const SpColumn = styled.span`
  padding: 0 5px;
  white-space: nowrap;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  --font-family-sans-serif: -apple-system, BlinkMacSystemFont, 'Segoe UI',
    Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif,
    'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas,
    'Liberation Mono', 'Courier New', monospace;
  font-famly: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji',
    'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1.5;
  a {
    color: inherit;
  }
  width: ${(props) => props.w}%;
  max-width: ${(props) => props.w}%;
  min-width: ${(props) => props.w}%;
  text-align: ${(props) => props.align};
  box-sizing: border-box;
`

//moving slider
export const moveSliderStyle = {
  // Give the slider some width
  width: 450,
  position: 'relative',
  height: 20,
  marginLeft: '15px',
  marginTop: 20,
}

export const moveRailStyle = {
  position: 'absolute',
  width: '101%',
  height: '50%',
  cursor: 'pointer',
  marginLeft: '-1px',
  borderRadius: 5,
  backgroundColor: 'lightgrey',
}

export const sliderStyle = {
  // Give the slider some width
  position: 'relative',
  //width: '96%',
  height: 80,
  marginRight: 15, //
  marginLeft: 40,
}

export const railStyle = {
  position: 'absolute',
  width: '100%',
  height: 2,
  marginTop: 15,
  borderRadius: 5,
  backgroundColor: 'lightgrey',
}

export const MeteoHighchartsContainer = styled.div``
